import { doc, getDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Spinner from "../components/Spinner";
import { db } from "../firebase";
import parse from "html-react-parser";

export default function Post() {
	const [loading, setLoading] = useState(true);
	const [post, setPost] = useState(null);
	const params = useParams();

	useEffect(() => {
		async function fetchPosts() {
			const docRef = doc(db, "listings", params.postId);
			const docSnap = await getDoc(docRef);
			if (docSnap.exists()) {
				setPost(docSnap.data());
				setLoading(false);
			}
		}
		fetchPosts();
	}, [params.postId]);

	if (loading) {
		return <Spinner />;
	}

	return (
		<main>
			<div className="relative w-full bg-gradient-to-r from-transparent via-teal-700 to-transparent px-6 py-4 my-8 mx-auto justify-center flex items-end shadow-md hover:shadow-lg">
				<h1 className="text-3xl font-bold text-gray-100 whitespace-nowrap truncate">
					{post.name}
				</h1>
				<h1 className="mx-2 italic">by</h1>
				<h1 className="text-xl font-semibold text-gray-100 whitespace-nowrap truncate">
					{post.artist}
				</h1>
				<span className="absolute px-2 py-1 top-14 uppercase text-xs rounded-full bg-teal-900">
					{post.type}
				</span>
			</div>
			<div className="relative w-[90%] md:w-[70%] flex flex-col md:block mx-auto mb-10">
				<img
					src={post.imgUrl}
					alt="Album Art"
					className="w-96 object-contain mx-auto sm:ml-5 mb-8 sm:mb-2 rounded-md float-right"
				/>

				<div className="mx-auto font-semibold text-justify">
					{parse(post.review)}
				</div>
				<div className="flex space-x-4">
					<div className="w-fit p-2 text-teal-400 border border-teal-400 text-lg font-bold my-4 rounded-md">
						Overall Rating: {post.rating}/10
					</div>
					<div className="w-fit p-2 text-teal-400 border border-teal-400 text-lg font-bold my-4 rounded-md">
						Year of Release: {post.year}
					</div>
				</div>
			</div>
		</main>
	);
}
